import { useContext } from 'react';
import styles from './CompositionAdvancedOptions.module.css';
import ThemeContext from 'config/context/themeContext';
import ModalDropdown from 'components/shared/modal/ModalDropdown';
import { DescIcon, PlusIcon } from 'features/compositions/assets/icons/icons';
import { NavLink } from 'react-router-dom';
import PageSizeSelector from './PageSizeSelector';
import CompositionOperators from './CompositionOperators';
import FilterComponent from './FilterComponent';
import FilterActions from './FilterActions';
// Provider is applied at the view level; do not wrap again here
import { useCompositionsContext } from 'features/compositions/context/CompositionsContext';
import { useCompositionAdvancedOptionsContext } from 'features/compositions/context/CompositionAdvancedOptionsContext';
import ScopeSelector from './ScopeSelector';
import DatabaseSelector from './DatabaseSelector';

const CompositionAdvancedOptionsComponent = () => {
    const { dark } = useContext(ThemeContext);
    const { compositionNames, selectComposition, selectedComposition } = useCompositionsContext();
    const { sortBy, setSortBy, viewType, setViewType, reverse, setReverse } = useCompositionAdvancedOptionsContext();


    return (
        <div className={`${styles.composition_advanced_options} ${dark ? styles.dark : ''}`}>
            <div className={styles.permission}>
                Permission: <span>{selectedComposition?.permission}</span>
            </div>

            <DatabaseSelector />

            <div className={styles.select_option_group}>
                <div className={styles.label}>
                    Composition <span>({compositionNames?.length})</span>
                </div>
                <div className={styles.select_option_row}>
                    <ModalDropdown
                        title={selectedComposition?.name || "Composition"}
                        options={compositionNames}
                        setOption={(val) => { selectComposition(val) }}
                    />
                    <NavLink to="/compositions/add-composition" className={styles.add_btn}><PlusIcon /></NavLink>
                </div>
            </div>

            <ScopeSelector />

            <div className={styles.divider} />

            <PageSizeSelector />

            <div className={styles.select_option_group}>
                <div className={styles.label}>
                    View type
                </div>
                <div className={styles.select_option_row}>
                    <ModalDropdown
                        title={viewType === 'structure' ? 'Structure' : 'Browse (default)'}
                        options={["browse", "structure"]}
                        setOption={(val) => { setViewType(val); }}
                    />
                </div>
            </div>

            <div className={styles.divider} />

            <CompositionOperators />
            <div className={styles.select_option_group}>
                <div className={styles.label}>Sort by</div>
                <div className={styles.select_option_row}>
                    <ModalDropdown
                        title={sortBy || "Select field"}
                        options={(selectedComposition?.structure?.indexes || []).concat(selectedComposition?.structure?.fields || []).map(f => ({ value: f.name, label: f.name }))}
                        setOption={(val) => { setSortBy(val); }}
                    />
                    <button onClick={()=> setReverse(!reverse)} className={styles.reverse_btn}><DescIcon color={reverse ? "#239dce" : ""} /></button>
                </div>
            </div>
            <div className={styles.filters}>
                {selectedComposition && (
                    (selectedComposition?.structure?.indexes || []).map(f => (
                        <FilterComponent key={f.meta_name} id={f.name} type={f.type} label={f.name} />
                    ))
                )}
            </div>
            <FilterActions />
        </div>
    )
}

export default CompositionAdvancedOptionsComponent;